import { render, staticRenderFns } from "./card-editor.pug?vue&type=template&id=544067d3&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./card-editor.scss?vue&type=style&index=0&id=544067d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544067d3",
  null
  
)

export default component.exports